import invariant from "invariant";
import { User, UserManager } from "oidc-client";
import { useContext, useCallback } from "react";
import { SecurityContext } from "./security.context";
import { hasRole, isLoggedIn, getUserRoles, isAuthenticated } from "./utils";

interface UseSecurity {
  user: User; 
  userManager: UserManager, 
  unauthenticatedElement: JSX.Element, 
  unauthorizedElement: JSX.Element,
  loggedIn: boolean, 
  authenticated: boolean, 
  defaultRoles: string[],
  isInRole: (r: string []) => boolean,
  signIn: () => Promise<void>,
  signOut: () => Promise<void>,
  log: (m: any[] | string) => void,
}

export const useSecurity = (): UseSecurity => {
  const securityContext = useContext(SecurityContext);
  invariant(securityContext, "SecurityContext value has not been set");
  
  const { log, user, userManager, unauthenticatedElement, unauthorizedElement, defaultRoles } = securityContext;

  const loggedIn = isLoggedIn(user);
  const userRoles = getUserRoles(user);
  const authenticated = isAuthenticated(user);
  const isInRole = useCallback((validRoles: string[]) => hasRole(userRoles, validRoles), [user]);

  const signIn = useCallback((): Promise<void> => {
      const state = window.location.pathname + window.location.search;
      log!(state);
      return userManager!.signinRedirect({ state });
    }, [userManager]);

  const signOut =useCallback((): Promise<void> =>  userManager!.signoutRedirect(), [userManager]);


  return { user: user!, 
    userManager: userManager!, 
    unauthenticatedElement: unauthenticatedElement!, 
    unauthorizedElement: unauthorizedElement!, 
    loggedIn, 
    authenticated, 
    defaultRoles: defaultRoles!,
    isInRole,
    signIn,
    signOut,
    log: log!,
  };
};